import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { noteServices } from "../../../APIServices/SitePilotManagement/noteServices";

const AddNotes = ({ setAction, getNoteList, contactId }) => {
  const [note, setNote] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewNote = async () => {
    setLoader(true)
    let userData = {}
    userData.contactId = contactId
    userData.note = note
    let data = await noteServices.addNewNote(userData)
    if (data?.statusCode === 200) {
      getNoteList()
      clearData();
    }
    setLoader(false)
  }

  const clearData = () => {
    setNote("");
    setAction("");
    setLoader(false)
  }

  useEffect(() => {
    if (contactId) {
      setNote("");
      setLoader(false)
    }
  }, [contactId]);

  return (
    <Form>
      <Form.Group classNote="mb-2">
        <Form.Label>Notes</Form.Label>
        <Form.Control
          note="notes"
          as={`textarea`}
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter Notes"
        />
      </Form.Group>
      <div className="d-flex justify-content-end gap-2 mt-3">
        <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
          Cancel
        </Button>
        <Button
          disabled={!note || loader}
          onClick={addNewNote}
          style={{ fontSize: 12 }}>
          Add New
        </Button>
      </div>
    </Form>
  );
};

export default AddNotes;
